import { redirect } from "@tanstack/react-router";
import type { AppStore } from "../../redux/store";
import { getSafeRedirectPath } from "../../utils/redirect";

/** The auth state once any in-flight token login (the boot-time session restore, or a sign-in) has finished. */
export async function settledAuth(store: AppStore) {
  if (store.getState().auth.loading) {
    await new Promise<void>((resolve) => {
      const unsubscribe = store.subscribe(() => {
        if (store.getState().auth.loading) return;
        unsubscribe();
        resolve();
      });
    });
  }
  return store.getState().auth;
}

/** `beforeLoad` for login and signup: signed-in users go on to `?redirect=` (set by the auth guard), or their dashboard. */
export async function forwardSignedInUser({
  context,
  search,
}: {
  context: { store: AppStore };
  search: { redirect?: string };
}) {
  const { isAuthenticated } = await settledAuth(context.store);
  if (isAuthenticated) {
    throw redirect({ href: getSafeRedirectPath(search.redirect), replace: true });
  }
}
